export default __webpack_public_path__ + "5173a02dbb0273861067bb197e6d1b93.svg";